import Vue from 'vue';

export default {
  SET_PROJECTS_WITH_HOURS_BY_USERS: (state, response) => {
    Vue.set(state, 'allProjectsWithLoggedHoursByUsers', response);
  },
  SET_LOGGED_HOURS_BY_PROJECT: (state, response) => {
    Vue.set(state, 'loggedHoursByProject', response);
  },
  SET_PLANNED_HOURS_BY_PROJECT: (state, response) => {
    Vue.set(state, 'plannedHoursByProject', response);
  },
  SET_PLANNED_HOURS_BY_USER: (state, response) => {
    Vue.set(state, 'plannedHoursByUser', response);
  }
};
